export { default as TextSentence } from "./TextSentence/TextSentence";
export { default as TextTitle } from "./TextTitle/TextTitle";
